module.exports = __webpack_public_path__ + "static/media/banner_mobil.f191fd70.png";